import { render, staticRenderFns } from "./InputCertNumber.vue?vue&type=template&id=163ca71e&"
import script from "./InputCertNumber.vue?vue&type=script&lang=js&"
export * from "./InputCertNumber.vue?vue&type=script&lang=js&"
import style0 from "./InputCertNumber.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports